export default __webpack_public_path__ + "img/bsp-logo.8653722c.png";